import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-3 col-sm-6" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "col-lg-3 col-sm-6"
}
const _hoisted_8 = { class: "form-group mb-4" }
const _hoisted_9 = { value: null }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-lg-3 col-sm-6" }
const _hoisted_12 = { class: "form-group mb-4" }
const _hoisted_13 = { value: null }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "col-lg-3 col-sm-6" }
const _hoisted_16 = { class: "form-group mb-4" }
const _hoisted_17 = { value: null }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-lg-3 col-sm-6 text-end mt-4" }
const _hoisted_20 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }
const _hoisted_21 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_22 = { class: "card-body p-0" }
const _hoisted_23 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-lg-3 col-sm-6" }
const _hoisted_26 = { class: "form-group mb-4" }
const _hoisted_27 = { value: null }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "col-lg-3 col-sm-6" }
const _hoisted_30 = { class: "form-group mb-4" }
const _hoisted_31 = { value: 0 }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "col-lg-3 col-sm-6" }
const _hoisted_34 = { class: "form-group mb-4" }
const _hoisted_35 = { value: 0 }
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "col-lg-3 col-sm-6 text-end mt-4" }
const _hoisted_38 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[18] || (_cache[18] = _createElementVNode("h4", null, "Engament", -1 /* HOISTED */)),
            _createElementVNode("form", {
              class: "position-relative table-src-form me-0",
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label text-secondary strong" }, "Tipo de reporte", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reportType) = $event)),
                      class: "form-select form-control h-45",
                      "aria-label": "Default select example"
                    }, _cache[13] || (_cache[13] = [
                      _createElementVNode("option", { value: "player" }, "Por Jugador", -1 /* HOISTED */),
                      _createElementVNode("option", { value: "team" }, "Por Equipo", -1 /* HOISTED */)
                    ]), 512 /* NEED_PATCH */), [
                      [_vModelSelect, _ctx.reportType]
                    ])
                  ])
                ]),
                _createCommentVNode(" Filtros para reporte Por Jugador "),
                (_ctx.reportType === 'player')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label text-secondary strong" }, "Empresa", -1 /* HOISTED */)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.companyId) = $event)),
                          class: "form-select form-control h-45",
                          "aria-label": "Default select example"
                        }, [
                          _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsCompany, (item, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.id,
                              key: i
                            }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_10))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, _ctx.filters.companyId]
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createCommentVNode(" Filtros para reporte Por Equipo "),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label text-secondary strong" }, "Torneo", -1 /* HOISTED */)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.tournamentId) = $event)),
                            class: "form-select form-control h-45",
                            "aria-label": "Default select example"
                          }, [
                            _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTournament, (item, i) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.id,
                                key: i
                              }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_14))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 512 /* NEED_PATCH */), [
                            [_vModelSelect, _ctx.filters.tournamentId]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label text-secondary strong" }, "Empresa", -1 /* HOISTED */)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.companyId) = $event)),
                            class: "form-select form-control h-45",
                            "aria-label": "Default select example"
                          }, [
                            _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsCompany, (item, i) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.id,
                                key: i
                              }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_18))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 512 /* NEED_PATCH */), [
                            [_vModelSelect, _ctx.filters.companyId]
                          ])
                        ])
                      ])
                    ], 64 /* STABLE_FRAGMENT */)),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.getReport()), ["prevent"])),
                      class: "btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                    }, " Generar reporte ")
                  ])
                ])
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[22] || (_cache[22] = _createElementVNode("h4", null, "Drop/Cancelación de jugada", -1 /* HOISTED */)),
            _createElementVNode("form", {
              class: "position-relative table-src-form me-0",
              onSubmit: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "label text-secondary strong" }, "Torneo", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filtersDrop.tournamentId) = $event)),
                      class: "form-select form-control h-45",
                      "aria-label": "Default select example",
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getMatchesByTournament()))
                    }, [
                      _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.LABELS.SELECT), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTournament, (item, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.id,
                          key: i
                        }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_28))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, _ctx.filtersDrop.tournamentId]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", { class: "label text-secondary strong" }, "Partido", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filtersDrop.matchId) = $event)),
                      class: "form-select form-control h-55",
                      "aria-label": "Default select example",
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getPlayByTournamentMatch()))
                    }, [
                      _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsMatch, (item, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.id,
                          key: i
                        }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_32))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, _ctx.filtersDrop.matchId]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "label text-secondary strong" }, "Jugada", -1 /* HOISTED */)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filtersDrop.playId) = $event)),
                      class: "form-select form-control h-55",
                      "aria-label": "Default select example"
                    }, [
                      _createElementVNode("option", _hoisted_35, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPlay, (item, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.id,
                          key: i
                        }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_36))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, _ctx.filtersDrop.playId]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.getReportDrop()), ["prevent"])),
                      class: "btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                    }, " Generar reporte ")
                  ])
                ])
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}